import React from "react";
import { withRouter } from "react-router-dom";
import * as etiquetas from '../../ApplicationResources';
import errorImgModal from '../../img/error_icon.svg';
import advertenciaImgModal from '../../img/infow_icon.png';
import notificacionImgModal from '../../img/icons/icono_verificacion.svg';
import { Button, Col, Input, Modal } from "antd";
import { connect } from "react-redux";

/**
 * Componente que despliega un modal informativo. Se necesitan las siguientes props:
 *  tipoMensaje: Indica el tipo de mensaje a desplegar, estos tipos se encuentran en el archivo ApplicationResources
 *               y pueden ser CONSTANTE_MODAL_TIPO_MENSAJE_ERROR, CONSTANTE_MODAL_TIPO_MENSAJE_ADVERTENCIA y CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION
 *  mensaje: Permite establecer el mensaje informativo a desplegar. Tipo String, texto.
 *  abrirModal: Indica si el modal será desplegado o no. Valor booleano true o false (utilizar mediante un state en el padre).
 *  cerrarModal: Función que actualizará la props abrirModal (actualizará el estate desde el padre) que permitirá cerrar el modal.
 */
class ModalMensajes extends React.Component {
    constructor(props) {
        super(props);
    }

    obtenerTipoImagen = () => {
        switch(this.props.tipoMensaje) {
            case etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ERROR:
                return <img  src={errorImgModal} id="img-error-modal"/>;
            case etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_ADVERTENCIA:
                return <img  src={advertenciaImgModal} id="img-error-modal"/>;
            case etiquetas.CONSTANTE_MODAL_TIPO_MENSAJE_NOTIFICACION:
                return <img  src={notificacionImgModal} id="img-error-modal"/>;
        }
    }

    render() {
        return(
            <Modal
                className="modalError"
                title={this.props.tipoModal === etiquetas.CONSTANTE_MODAL_TIPO_MODAL_INPUT_TEXT ? null : this.obtenerTipoImagen()}
                centered
                onCancel={()=>this.props.cerrarModal()}
                visible={this.props.abrirModal}
                footer={false}
                width={400}
            >
                <div className="modalMensajesMensajePrincipal">{this.props.mensaje}</div>
                {
                    this.props.tipoModal === etiquetas.CONSTANTE_MODAL_TIPO_MODAL_CONFIRMACION ? 
                        <div id="modal_botones">
                            <Button className="botonesModal" onClick={this.props.btnAceptarOnClick}>
                                Sí
                            </Button>
                            <Button className="botonesModal" onClick={this.props.cerrarModal}>
                                No
                            </Button>
                        </div> : ""
                }
                {
                    this.props.tipoModal === etiquetas.CONSTANTE_MODAL_TIPO_MODAL_INPUT_TEXT ? 
                        <div id="modal_botones">
                            <div className="modalMensajesInputText">
                                <Input value={this.props.txtInputTextValue} onChange={this.props.txtInputTextOnchange} /> 
                            </div>
                            <div>
                                <Button onClick={this.props.btnAceptarOnClick} disabled={this.props.txtInputTextValue.length === 0}>
                                    Aceptar
                                </Button>
                            </div>
                        </div>
                        : ""
                }
            </Modal>
        );
    }
}

export default withRouter(connect()(ModalMensajes));